import React from "react";
import searchIcon from "../../../assets/icons/search.svg";
import Dropdown from "../../../common/components/Dropdown";
import { t } from "i18next";

function SearchBar({ onSearch, onSort, fullWidthDropdown = false }) {
    const sortOptions = [
        t('defaultSort'),
        t('dateDesSort'),
        t('dateAscSort'),
        t('priceAscSort'),
        t('priceDesSort')
    ];

    const handleInputChange = (e) => {
        onSearch(e.target.value);
    };

    const handleSortChange = (selectedOption) => {
        let sortValue = "";
        if (selectedOption === t('dateDesSort')) sortValue = "date_newest";
        else if (selectedOption === t('dateAscSort')) sortValue = "date_oldest";
        else if (selectedOption === t('priceAscSort')) sortValue = "price_low";
        else if (selectedOption === t('priceDesSort')) sortValue = "price_high";

        onSort(sortValue);
    };

    return (
        <div className="flex items-center w-full mb-5 gap-5 md:flex-row flex-col-reverse">
            <div className="relative flex items-center bg-white rounded-[10px] w-full flex-1">
                <img
                    className="absolute left-[15px] w-5 h-5 z-10"
                    src={searchIcon}
                    alt="search_icon"
                />
                <input
                    className="rounded-[10px] border-none w-full py-[10px] pl-[50px] pr-[15px] h-[40px] focus:outline-none focus:ring-2 focus:ring-[#147F26]"
                    placeholder={t('searchPlaceholder')}
                    onChange={handleInputChange}
                />
            </div>
            <div className="md:w-auto w-full">
                <Dropdown
                    text={t('sortBy')}
                    options={sortOptions}
                    onOptionSelect={handleSortChange}
                    width={fullWidthDropdown ? "full" : "s340"}
                />
            </div>
        </div>
    );
}

export default SearchBar;